import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../models/api.model';
import { Client, ClientList } from '../models/client.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ClientService {
  private apiUrl = `${environment.apiUrl}/booking/clients/`;

  constructor(private http: HttpClient) {}

  list(params?: HttpParams): Observable<PaginatedResponse<ClientList>> {
    return this.http.get<PaginatedResponse<ClientList>>(this.apiUrl, { params });
  }

  get(id: number): Observable<Client> {
    return this.http.get<Client>(`${this.apiUrl}${id}/`);
  }

  create(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data);
  }

  update(id: number, data: any): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}${id}/`, data);
  }

  search(query: string, params?: HttpParams): Observable<PaginatedResponse<ClientList>> {
    const merged = params ? params.set('search', query) : new HttpParams().set('search', query);
    return this.http.get<PaginatedResponse<ClientList>>(this.apiUrl, { params: merged });
  }
}